import styled from "styled-components";
import themeGet from "@styled-system/theme-get";

const SiteNav = styled("ul")`
  display: flex;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
  @media screen and (max-width: ${themeGet("breakpoints.md")}) {
    margin-left: 15px;
  }
`;

SiteNav.displayName = "SiteNav";

export default SiteNav;
